/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Vuex from 'vuex'

// Store functionality
import actions from './actions'
import getters from './getters'
import modules from './modules'
import mutations from './mutations'
import state from './state'
import stimulusHistory from '../views/consolidation/stimulusHistory/store.module'
import initiativeManager from '../views/initiativeManager/store.module'
import incentiveApproach from '../views/incentiveApproach/store.module'

Vue.use(Vuex)


modules['stimulusHistory'] = stimulusHistory
modules['initiativeManager'] = initiativeManager
modules['incentiveApproach'] = incentiveApproach

export default new Vuex.Store({
  actions,
  getters,
  modules,
  mutations,
  state,
});
